// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1yxo1","label":"styles_label__3pz14"};